import style from "../../assets/scss/sub/qna.module.scss";
import kakaotalkIcon from "../../assets/images/sub/purchase_voucher/kakaotalk_icon.svg";
import { useLanguage } from "../../hooks/hooks";

export function QnA() {
  const { isKorean } = useLanguage();
  return (
    <>
      {isKorean && (
        <div className={style.qnaArea}>
          <span className={style.anyQuestionsText}>문의사항이 있으신가요?</span>
          <button
            className={style.kakaoQnaBtn}
            onClick={() => window.open("https://pf.kakao.com/_txlSZxj/chat", "_blank")}
          >
            <img className={style.icon} src={kakaotalkIcon} alt={"카카오톡 아이콘"} />
            <span className={style.text}>카카오톡 1:1 문의</span>
          </button>
        </div>
      )}
    </>
  );
}
